import * as tslib_1 from "tslib";
import React from 'react';
import { CheckboxGroup as NativeCheckboxGroup } from 'sinoui-components/Checkbox';
import PropTypes from 'prop-types';
import Field from './Field';
export function renderCheckboxGroupField(_a) {
    var props = _a.props, field = _a.field, stringValue = _a.stringValue, children = _a.children, form = _a.form;
    return (React.createElement(NativeCheckboxGroup, tslib_1.__assign({}, props, field, { className: "sinoui-checkbox-group-field", error: form.touched[field.name] && form.errors[field.name], id: field.name, onBlur: function () { return form.setFieldTouched(field.name, true); }, value: stringValue && field.value ? field.value.split(',') : field.value || [], onChange: function (value) {
            form.setFieldValue(field.name, stringValue ? (value || []).join(',') : value);
            props.onChange && props.onChange(value, form);
        } }), children));
}
/**
 * 复选框组组件。
 */
var CheckboxGroup = /** @class */ (function (_super) {
    tslib_1.__extends(CheckboxGroup, _super);
    function CheckboxGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckboxGroup.prototype.getChildContext = function () {
        return {
            checkboxGroup: true,
        };
    };
    CheckboxGroup.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, stringValue = _a.stringValue, props = tslib_1.__rest(_a, ["children", "stringValue"]);
        return (React.createElement(Field, tslib_1.__assign({}, props, { render: function (_a) {
                var field = _a.field, form = _a.form;
                return renderCheckboxGroupField({
                    props: _this.props,
                    field: field,
                    stringValue: stringValue,
                    children: children,
                    form: form,
                });
            } })));
    };
    CheckboxGroup.childContextTypes = {
        checkboxGroup: PropTypes.bool,
    };
    return CheckboxGroup;
}(React.Component));
export default CheckboxGroup;
//# sourceMappingURL=CheckboxGroup.js.map